import React from 'react';
import './App.css';
import { useRecoilValue } from 'recoil';
import { pageState } from './stores/pageState';
import MainPage from './pages/MainPage';
import UnknownPage from './pages/UnknownPage';
import PreviewPage from './pages/PreviewPage';

function App() {
  const page = useRecoilValue(pageState);

  switch (page.location) {
    case 'main':
      return (<MainPage token={page.token}/>);
    case 'preview':
      return (<PreviewPage token={page.token} questionId={page.questionId}/>)
    case 'unknown':
      return (<UnknownPage/>)
  }
}

export default App;
